import {themeGetter} from 'quickstart/system'

// To allow for line-height of text in label
// const LINE_HEIGHT_ADJUSTMENTS = '0.15rem'

const getCheckboxes = (theme: any) => {
  const th = themeGetter(theme)
  return {
    label: {
      default: {
        ...th('ui.form'),
        color: th('colors.textColorMuted'),
        lineHeight: theme.toRem(18), // TODO - these are all related, and also to checkmark size
        paddingLeft: th('space.xs'),
      },
      checked: {
        fontWeight: th('fontWeights.bold'),
      },
      disabled: {
        color: th('colors.textColorMuted'),
      },
    },
    checkbox: {
      default: {
        backgroundColor: th('colors.backgroundColorWhite'),
        borderColor: th('colors.borderColor'),
        borderWidth: th('borderWidths.md'),
        borderStyle: 'solid',
        borderRadius: th('radii.none'),
        width: theme.toRem(18), // TODO
        height: theme.toRem(18), // TODO
        flexShrink: 0,
      },
      checked: {
        borderColor: th('colors.borderSelectedColor'),
        color: th('colors.buttonSolidFocus'),
      },
    },
  }
}

export default getCheckboxes
